import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { customerService } from '../services/customerService'
import { useEffect } from 'react'

export const useCustomerInfo = (id: string) => {
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['customerInfo', id],
    queryFn: async () => customerService.customerInfo(id),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    isLoading,
    data,
  }
}
